<template>
  <div id="addModal" aria-labelledby="addModalLabel1" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="exampleModalLabel1" class="modal-title">
            Add New Custom Indicator
          </h4>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="reset()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body card-blue">
          <form class="form-horizontal" @submit.prevent="handleSubmit">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="form-group row">
                    <label class="control-label text-right col-md-3">Description</label>
                    <div class="col-md-9">
                      <textarea id="description" v-model="newControlPoint.description" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('description')}" class="form-control" name="description" placeholder="Give Indicator Description" rows="4" />
                      <div v-if="submitted && errors.has('description')" class="text-danger">
                        {{ errors.first('description') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="form-group row">
                    <label class="control-label text-right col-md-3">Obligation</label>
                    <div class="col-md-9">
                      <div class="form-check">
                        <div class="custom-control custom-radio">
                          <input id="major" v-model="newControlPoint.obligation" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('obligation')}" class="custom-control-input" data-vv-as="obligation" name="obligation" type="radio" value="MAJOR_MUST">
                          <label class="custom-control-label" for="major">Major Must</label>
                        </div>
                      </div>
                      <div class="form-check">
                        <div class="custom-control custom-radio">
                          <input id="minor" v-model="newControlPoint.obligation" class="custom-control-input" name="obligation" type="radio" value="MINOR_MUST">
                          <label class="custom-control-label" for="minor">Minor Must</label>
                        </div>
                      </div>
                      <div class="form-check">
                        <div class="custom-control custom-radio">
                          <input id="recommendation" v-model="newControlPoint.obligation" class="custom-control-input" name="recommendation" type="radio" value="RECOMMENDATION">
                          <label class="custom-control-label" for="recommendation">Recommendation</label>
                        </div>
                      </div>
                      <div class="form-check">
                        <div class="custom-control custom-radio">
                          <input id="risk_factor" v-model="newControlPoint.obligation" class="custom-control-input" name="risk_factor" type="radio" value="Risk Factor">
                          <label class="custom-control-label" for="risk_factor">Risk Factor</label>
                        </div>
                      </div>
                      <div v-if="submitted && errors.has('obligation')" class="text-danger">
                        {{ errors.first('obligation') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn waves-effect waves-light btn-success" type="submit" @ok="save()">
                Save
              </button>
              <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AddIndicator',
  props: ['auditId'],
  data() {
    return {
      submitted: false,
      newControlPoint: {
        description: null,
        obligation: null
      }
    };
  },
  methods: {
    async save() {
      await this.$api.post(`audits/${this.auditId}/custom_control_points`, this.newControlPoint);
      this.$toastr.s('Custom control point created', 'Success!');
      this.reset();
      await this.$parent.getCustomControlPoints();
      $('#addModal').modal('toggle');
    },
    reset() {
      this.submitted = false;
      this.newControlPoint = {
        description: null,
        obligation: null
      };
    },
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save();
          }
        });
    }
  }
}
</script>

<style scoped>
#addModal {
  top: 10%;
}
</style>
